<template>
  <div id="product-browse">
    <transition name="slide-fade">
      <div
        v-if="hasSearchResult"
        id="search-result-content-header"
        class="text-center"
      >{{searchResultHeader}}</div>
    </transition>
    <div id="search-results-wrapper" class="main-content-width mx-auto mt-5 mb-9">
      <transition name="slide-fade">
        <div v-if="hasNoSearchResult" class="text-center noto-sans-sc-font-family" key="NoResult">
          <div id="search-result-hint" class="search-hint px-2">{{ searchResultHintText }}</div>
          <div id="search-result-full-hint" class="search-hint px-2">{{ searchResultFullHintText }}</div>
        </div>
        <div v-if="hasSearchResult" id="search-result-content-wrapper">
          <v-row
            no-gutters
            key="hasResult"
            class="px-sm-2 px-md-0 justify-space-around justify-sm-start"
          >
            <v-hover v-slot:default="{ hover }" v-for="(product, index) in products" :key="index">
              <v-col
                :class="{'elevation-5' : hover}"
                class="product-card-wrapper mt-4 ml-sm-3"
                cols="6"
                md="4"
              >
                <product-card
                  :title="product.tinyTitle"
                  :imageSrc="getProductImage(product.id, product.images[0])"
                  :displayPrice="product.amazonListings[0].displayPrice"
                  :rating="rating"
                  :id="product.id"
                ></product-card>
              </v-col>
            </v-hover>
          </v-row>
        </div>
      </transition>
      <div
        id="paging-wrapper"
        v-if="hasSearchResult"
        class="py-12 text-end noto-sans-sc-font-family"
      >
        <v-icon color="#666666">keyboard_arrow_left</v-icon>
        <span class="page-num pb-1">1</span>
        <v-icon color="#666666">keyboard_arrow_right</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import productSearchMixins from "../../mixins/productSearchMixins";
import ProductCard from "../components/ProductCard";

export default {
  components: {
    ProductCard
  },
  mixins: [productSearchMixins]
};
</script>

<style scoped>
#product-browse {
  width: 100%;
}

#search-result-content-header {
  border-bottom: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
  font-size: 30px;
  padding-top: 13px;
  padding-bottom: 13px;
}

#search-results-wrapper {
  position: relative;
}

.product-card-wrapper {
  max-width: 32%;
  background-color: #f6f6f7;
  border-radius: 3px;
  transition: 0.5s;
}
.product-card-wrapper:hover {
  background-color: white;
}

@media only screen and (max-width: 912px) {
  .skeleton-loader-wrapper,
  .product-card-wrapper {
    max-width: 47%;
  }
}

.skeleton-loader-wrapper {
  max-width: 32%;
}

.image-skeleton-loader {
  width: 100%;
  height: 300px;
}

.search-hint {
  color: #333333;
}

#search-result-hint {
  font-size: 30px;
  margin-top: 91px;
  position: relative;
}

#search-result-hint::before {
  height: 10px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  border-bottom: 4px solid #e2211c;
  content: "";
}

#search-result-full-hint {
  font-size: 18px;
  margin-top: 70px;
}

#paging-wrapper {
  color: #666666;
}

.page-num {
  color: black;
  border-bottom: #adadad 2px solid;
}
</style>
